var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-accordion",
      class: {
        "rb-accordion--with-custom-icon": _vm.hasCustomIcon,
        "rb-accordion--is-open": _vm.isOpen,
      },
      attrs: { id: _vm.id },
    },
    [
      _c(
        "button",
        {
          staticClass: "rb-btn rb-accordion__button",
          class: {
            "rb-accordion__button--open": _vm.isOpen,
            "rb-accordion__button--title": !!_vm.id,
          },
          attrs: {
            "aria-controls": _vm.id + "-answer",
            "aria-expanded": _vm.isOpen,
            "data-element-id": _vm.dataElementId,
          },
          on: { click: _vm.toggleAccordion },
        },
        [
          _vm._t("title"),
          _vm._v(" "),
          _vm.hasCustomIcon
            ? [_vm._t("icon")]
            : [
                _vm.isOpen
                  ? _c("rb-lazy-icon", { attrs: { icon: "caret-up" } })
                  : _c("rb-lazy-icon", { attrs: { icon: "caret-down" } }),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          attrs: { id: _vm.id + "-answer", "aria-hidden": !_vm.isOpen },
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }